import { ICrmCompanyProfile, ICrmContactProfile, IDirectoryEntry } from "../types/DirectoryEntry";

export const injectDirectoryEntryTypeIntoProfile = (directoryEntry: IDirectoryEntry): ICrmCompanyProfile | ICrmContactProfile => {
  return {
    ...directoryEntry.profile,
    type: directoryEntry.type,
  }
}
